module.exports = __webpack_public_path__ + "static/media/1.3-dashboard.c678bcf6.jpg";